import { Client } from 'openapi-fetch'

import type { paths } from '@kidzonet/ts-api-generator/clients/dashboard'
import type { paths as ispPaths } from '@kidzonet/ts-api-generator/clients/isp_api'

import { ALLOWED, BLOCKED, exclusionListResponse } from './Serializers'
import { ExclusionCreateInterface, ExclusionListParams } from './types'

declare global {
    // eslint-disable-next-line vars-on-top
    var DashboardApiClient: Client<paths>
    // eslint-disable-next-line vars-on-top
    var IspApiClient: Client<ispPaths>
    // eslint-disable-next-line vars-on-top
    var ExclusionListsApiClient: {
        getList: (query: ExclusionListParams) => ReturnType<typeof getIspApiExclusionList> | ReturnType<typeof getDashboardExclusionList>
        create: (params: ExclusionCreateInterface) => ReturnType<typeof addIspApiDomain> | ReturnType<typeof addDashboardDomain>
        remove: (id: number) => ReturnType<typeof deleteIspApiDomain> | ReturnType<typeof deleteDashboardDomain>
    }
}

export const getIspApiExclusionList = (query: ExclusionListParams) => {
    return globalThis.IspApiClient.GET('/v1/public/isp/exclusions', {
        params: {
            query,
        },
    })
}

export const getDashboardExclusionList = (query: ExclusionListParams) => {
    return globalThis.DashboardApiClient.GET('/v1/public/dashboard/exclusions', {
        params: {
            query,
        },
    })
}

export const addIspApiDomain = (body: ExclusionCreateInterface) => {
    return globalThis.IspApiClient.POST('/v1/public/isp/exclusions', {
        body,
    })
}

export const addDashboardDomain = (body: ExclusionCreateInterface) => {
    return globalThis.DashboardApiClient.POST('/v1/public/dashboard/exclusions', {
        body,
    })
}

export const deleteIspApiDomain = (id: number) => {
    return globalThis.IspApiClient.DELETE('/v1/public/isp/exclusions/{exclusion_id}', {
        params: { path: { exclusion_id: id } },
    })
}

export const deleteDashboardDomain = (id: number) => {
    return globalThis.DashboardApiClient.DELETE(`/v1/public/dashboard/exclusions/{exclusion_id}`,
        {
            params: { path: { exclusion_id: id } },
        })
}

interface GetExclusionListParamsInterface {
    page: number
    perPage: number
    desc: boolean
}

export const getAllowedList = async (
    { page = 1, perPage = 20, desc = false }: GetExclusionListParamsInterface = { page: 1, perPage: 20, desc: false },
) => {
    const resp = await globalThis.ExclusionListsApiClient.getList({
        type: ALLOWED,
        sort: 'DOMAIN',
        page,
        size: perPage,
        desc,
    })
    return exclusionListResponse(resp)
}

export const getBlockedList = async (
    { page = 1, perPage = 20, desc = false }: GetExclusionListParamsInterface = { page: 1, perPage: 20, desc: false },
) => {
    const resp = await globalThis.ExclusionListsApiClient.getList({
        type: BLOCKED,
        sort: 'DOMAIN',
        page,
        size: perPage,
        desc,
    })
    return exclusionListResponse(resp)
}

export const addExclusion = async ({ domain, type }: ExclusionCreateInterface) => {
    const { data, error } = await globalThis.ExclusionListsApiClient.create({
        type,
        domain,
    })
    if (data) {
        return data
    }
    if ('status' in error && error?.status === 409) {
        return error
    }
    throw error
}

export const deleteExclusion = async (id: number) => {
    const { data, error } = await globalThis.ExclusionListsApiClient.remove(id)
    if (data) {
        return true
    }
    if ('status' in error && error?.status === 404) {
        return true
    }
    throw error
}
